import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { User } from "../endpoints/models/user.model";
import { environment } from "src/environments/environment";
import { Observable, tap } from "rxjs";
import { Router } from "@angular/router";
import { AuthService } from "../endpoints/auth.service";

@Injectable({
	providedIn: "root",
})
export class ApiService {
	public httpOptions: any;

	constructor(public http: HttpClient, private router: Router) {}

	/**
	 * Método para realizar inicio de sesión
	 * @param email
	 * @param password
	 * @param remember_me
	 * @returns
	 */
	// public login(user: User): Observable<any> {
	// 	return this.http.post(environment.api.url + "login", user);
	// }
	public login(email: String, password: String): Observable<any> {
		return this.http
			.post(environment.api.url + "login", { email: email, password: password })
			.pipe(
				tap((dataLogin) => {
					if (dataLogin.access_token && dataLogin.status === 1)
						ApiService.setAuthToken(dataLogin);
					else ApiService.removeAuthToken();
					return dataLogin;
				})
			);
	}

	public static removeAuthToken() {
		localStorage.removeItem("AuthTokenWeb");
		localStorage.removeItem("dataUserWeb");
	}

	public static setAuthToken(dataLogin: any) {
		localStorage.setItem("AuthTokenWeb", dataLogin.access_token);
		ApiService.setDataUser(dataLogin.user_data);
		ApiService.setDataLogin(dataLogin);
	}

	public static setDataLogin(dataLogin: any) {
		dataLogin.generated_at = new Date();
		localStorage.setItem("dataLoginWeb", JSON.stringify(dataLogin));
	}

	public static setDataUser(dataUser: any) {
		localStorage.setItem("user", JSON.stringify(dataUser));
	}

	/**
	 * Método para recuperación de cuenta
	 * @param email
	 * @returns
	 */
	public forgotPassword(email: any): Observable<any> {
		return this.http.post(environment.api.url + "recover", {
			email:email
		});
	}

	/**
	 * Obtener datos de entidad desde API
	 * @param entity
	 * @param id
	 * @returns
	 */
	public getEntity(entity: string, id?: number): Observable<any> {
		if (id == null) {
			return this.http.get(environment.api.url + entity, this.httpOptions);
		} else {
			return this.http.get(
				environment.api.url + entity + "/" + id,
				this.httpOptions
			);
		}
	}

	/**
	 * Agregar entidad a API
	 * @param entity
	 * @param parametres
	 * @returns
	 */
	public addEntity(entity: string, parametres?: any): Observable<any> {
		return this.http.post(
			environment.api.url + entity,
			parametres,
			this.httpOptions
		);
	}

	/**
	 * Agregar entidad a API usando formularios mediante FormData
	 * @param entity
	 * @param documents
	 * @returns
	 */
	public addEntityFormData(
		entity: string,
		formData: FormData
	): Observable<any> {
		return this.http.post(
			environment.api.url + entity,
			formData,
			this.httpOptions
		);
	}

	/**
	 * Actualizar entidad existente en API
	 * @param entity
	 * @param id
	 * @param parametres
	 * @returns
	 */
	public updateEntityFormData(
		entity: string,
		id: number,
		FormData: FormData
	): Observable<any> {
		return this.http.put(
			environment.api.url + entity + "/" + id,
			FormData,
			this.httpOptions
		);
	}

	public updateEntity(
		entity: string,
		id: number,
		parametres: any
	): Observable<any> {
		return this.http.put(
			environment.api.url + entity + "/" + id,
			parametres,
			this.httpOptions
		);
	}

	/**
	 * Eliminar entidad de API
	 * @param entity
	 * @param id
	 * @returns
	 */
	public deleteEntity(entity: string, id: number): any {
		return this.http.delete(
			environment.api.url + entity + "/" + id,
			this.httpOptions
		);
	}

	/**
	 * Establecer token de autenticación a HTTPHeader
	 * @param token
	 */
	public setToken(token: any) {
		this.httpOptions = {
			headers: new HttpHeaders({
				Authorization: `Bearer ${token}`,
			}),
		};
	}

	public async logout() {
		try {
			this.http
				.post(
					environment.api.url + "logout",
					localStorage.getItem("dataUserWeb")
				)
				.subscribe();
		} catch (error) {}

		this.router.navigate(["login"], { replaceUrl: true });
		AuthService.removeAuthToken();
	}

	/**
	 * Eliminar el token de autorización HTTP
	 */
	public removeToken() {
		this.httpOptions = {
			headers: new HttpHeaders({
				"Content-Type": "application/json",
			}),
		};
	}
}
